import { render, staticRenderFns } from "./AccountPublishFundingApplicationForm.vue?vue&type=template&id=3849a130&"
import script from "./AccountPublishFundingApplicationForm.vue?vue&type=script&lang=ts&"
export * from "./AccountPublishFundingApplicationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports